import getDevUrl from '@providers/url'

const services = {
  main: {
    useSubscriptions: true,
    urls: {
      local: `http://localhost:3000`,
      dev: getDevUrl,
      prod: 'https://websites-api.getjusto.com'
    }
  },
  example: {
    useSubscriptions: false,
    urls: {
      local: `http://localhost:4100`,
      dev: 'https://example-orionjs.service.bejusto.com',
      prod: 'https://example-orionjs.service.getjusto.com'
    }
  }
}

export default services
